import { render, staticRenderFns } from "./ConfirmProjectOnHoldDialog.vue?vue&type=template&id=07c45682"
import script from "./ConfirmProjectOnHoldDialog.vue?vue&type=script&lang=ts"
export * from "./ConfirmProjectOnHoldDialog.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmProjectOnHoldDialog.vue?vue&type=style&index=0&id=07c45682&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports